import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import dayjs from 'dayjs';
import { Subscription, timer } from 'rxjs';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { ConfigService } from './json-config.service';
import { LOCAL_STORAGE_KEYS, LocalStorageService } from './local-storage.service';
import { LogoutService } from './logout.service';
import { UserService } from './user/user.service';
import { CLIENT_PEEK_ROUTE } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class TimeoutLogoutService {
  private timerSubscription?: Subscription;

  public constructor(
    private router: Router,
    private configService: ConfigService,
    private logoutService: LogoutService,
    private userService: UserService,
    private localStorageService: LocalStorageService,
  ) { }

  public initIdleTimeoutLogout(): void {
    this.checkInactiveReload();

    // todo optimize/debounce this?
    // todo - add some service for window watchers - issues/127
    window.addEventListener('click', this.refreshTimer.bind(this));
    window.addEventListener('scroll', this.refreshTimer.bind(this));

    this.router.events.subscribe((val) => {
        if (val instanceof NavigationStart) {
          this.refreshTimer();
        }
    });
  }

  private checkInactiveReload(): void {
    const lastActiveDate = this.localStorageService.getItemSync({key: LOCAL_STORAGE_KEYS.LOCAL_STORAGE_TIMER_KEY})
    const now = dayjs();
    const turnedOffIdleLogoutRoutes = [
      CLIENT_PEEK_ROUTE
    ];
    const routeWithoutIdleLogout = turnedOffIdleLogoutRoutes.some(route => window.location.href.includes(route));

    if(
      lastActiveDate &&
      lastActiveDate.length &&
      now.diff(lastActiveDate, 'minutes') >= this.configService.getConfig(EnvironmentKeys.logoutAfterIdleForMinutes) &&
      !routeWithoutIdleLogout
    ) {
      this.logoutService.logOut({withMessage: 'idleLogoutMessage'});
    }
  }

  public refreshTimer(): void {
    if(!this.userService.loggedConsult) {
      this.localStorageService.deleteItemSync({ key: LOCAL_STORAGE_KEYS.LOCAL_STORAGE_TIMER_KEY });
      return;
    }

    this.localStorageService.setItem({
      key: LOCAL_STORAGE_KEYS.LOCAL_STORAGE_TIMER_KEY,
      value: dayjs().format()
    });

    const timeInMs = this.configService.getConfig(EnvironmentKeys.logoutAfterIdleForMinutes) * 60000;

    if (this.timerSubscription && !this.timerSubscription.closed) {
      this.timerSubscription.unsubscribe();
    }

    this.timerSubscription = timer(timeInMs).subscribe(() => {
      this.logoutService.logOut({withMessage: 'idleLogoutMessage'});
    });
  }
}
